export default __webpack_public_path__ + "chat-sm.16d89fbb.svg";